
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinpunee() {



const cardData =
{
  keyword: 'Corporate Cab Service in Pune',
  heading: 'eTravo: Corporate Cab Service in Pune',
  headingDescription: 'eTravo provides dependable and professional Corporate Cab Service in Pune, designed to meet the daily transportation needs of businesses, employees, and corporate travelers across the city. Whether you need daily employee commute solutions, executive cabs for business meetings, or airport transfers for visiting clients, our services are designed to be punctual, comfortable, and customizable. With GPS-enabled vehicles, professional chauffeurs, and flexible booking options, eTravo helps companies of all sizes manage seamless corporate transportation across Pune, Hinjewadi, Kharadi, Viman Nagar, Baner, Wakad, Pimpri-Chinchwad, and nearby business and industrial areas.',

  top: 'Top Corporate Business Landmarks in Pune Served by eTravo',
 topPlaces: [
  {
    title: 'Hinjewadi IT Park',
    description: 'One of Pune’s major corporate and technology hubs, Hinjewadi is home to numerous IT companies, startups, and multinational offices. eTravo provides scheduled corporate cab services for employee shifts, executive travel, client visits, and daily office commutes.'
  },
  {
    title: 'Kharadi & EON Free Zone',
    description: 'Kharadi is a prominent business and IT destination with offices, technology parks, and commercial establishments. Our corporate cab services include employee transportation, executive cabs, airport transfers, and flexible point-to-point travel for businesses.'
  },
  {
    title: 'Viman Nagar',
    description: 'Located close to Pune Airport and several commercial hubs, Viman Nagar is a preferred location for corporate offices and business travelers. eTravo offers reliable cabs for airport pickups, client meetings, employee commutes, and executive transportation.'
  },
  {
    title: 'Baner & Balewadi',
    description: 'These rapidly developing business and commercial areas attract IT companies, startups, and professional service firms. eTravo provides AC corporate cabs for daily employee travel, meetings, client transfers, and on-demand business transportation.'
  },
  {
    title: 'Magarpatta City',
    description: 'Magarpatta is a well-established corporate and IT destination with offices and business centers. Our cab solutions support companies with scheduled staff transportation, executive travel, multi-stop bookings, and convenient office-to-home transfers.'
  },
  {
    title: 'Pimpri-Chinchwad Industrial Area',
    description: 'A major industrial and manufacturing belt of Pune, Pimpri-Chinchwad requires dependable employee and workforce transportation. eTravo provides fixed-route cabs, shift-based transportation, and customized corporate cab plans for companies operating across the region.'
  },
  {
    title: 'Yerawada & Pune Business Districts',
    description: 'With corporate offices, commercial establishments, and business centers across the area, Yerawada requires convenient transportation for employees and professionals. eTravo offers scheduled cabs, executive rentals, and point-to-point corporate travel solutions.'
  },
  {
    title: 'Hadapsar',
    description: 'Hadapsar is a growing commercial and technology hub with offices, IT parks, and business establishments. eTravo provides employee commute services, office shuttle solutions, executive cabs, and flexible transportation for companies of different sizes.'
  },
  {
    title: 'Pune Airport',
    description: 'Pune Airport is an important travel point for corporate employees, executives, and visiting clients. eTravo offers pre-booked airport pickup and drop services with professional chauffeurs, GPS-enabled vehicles, and punctual corporate transportation.'
  },
  {
    title: 'Chakan MIDC & Industrial Corridor',
    description: 'Chakan is a major manufacturing and industrial hub near Pune, serving automotive, logistics, engineering, and other businesses. eTravo provides scalable staff transportation, shift-based cab services, long-distance employee pickups, and customized corporate travel solutions.'
  }
],

 services: [
  {
    name: 'Pune Corporate Cab Rentals',
    description: 'Customized cab rental solutions for Pune-based offices, IT companies, manufacturing units, and startups. We offer flexible rental plans for employee travel, corporate events, business meetings, and management mobility.'
  },
  {
    name: 'Business Cab Services Pune',
    description: 'Daily and on-call cab services designed for business owners, field teams, executives, and visiting clients. Choose from sedan, SUV, or executive-class vehicles with professional chauffeurs and route tracking.'
  },
  {
    name: 'Employee Transport Cab Pune',
    description: 'Fixed-route employee transportation with optimized pickup and drop schedules, GPS tracking, and dedicated driver support. Ideal for shift-based operations and daily staff travel across Pune.'
  },
  {
    name: 'Corporate Staff Cabs Pune',
    description: 'End-to-end cab coordination for daily staff commutes, team transfers, and multi-stop business routes across Pune’s IT parks, commercial areas, and industrial zones.'
  },
  {
    name: 'Reliable Corporate Cab Service Pune',
    description: 'We support Pune-based companies with timely cab arrivals, clean vehicles, professional chauffeurs, and organized trip planning for regular employee transportation and business travel.'
  },
  {
    name: 'AC Corporate Cabs Pune',
    description: 'Our fully air-conditioned and well-maintained cabs provide comfortable transportation for employees, executives, and corporate guests, helping ensure a smooth travel experience throughout Pune.'
  },
  {
    name: 'Pune Office Commute Cabs',
    description: 'Our office commute cabs support multiple pickup points across Hinjewadi, Kharadi, Baner, Wakad, Viman Nagar, Hadapsar, and Pimpri-Chinchwad with scheduled pickup and drop management.'
  },
  {
    name: 'Corporate Event Cab Rentals Pune',
    description: 'Hosting a corporate meeting, conference, or offsite in Pune? We provide bulk cab bookings, guest transportation, and full-day cab availability to help manage event mobility efficiently.'
  },
  {
    name: 'Affordable Corporate Cabs Pune',
    description: 'With flexible billing options, monthly contracts, and customized transportation plans, our corporate cab services provide practical and cost-effective solutions for businesses of different sizes.'
  },
  {
    name: 'Executive Cab Service Pune',
    description: 'Our executive cab services are designed for company directors, senior managers, business partners, and visiting clients, featuring premium vehicles, professional chauffeurs, and punctual service.'
  },
  {
    name: 'Pune Business Travel Cabs',
    description: 'Whether traveling within Pune, Pimpri-Chinchwad, or nearby business hubs for meetings, site visits, or client appointments, our business cab solutions provide safe, comfortable, and scheduled transportation.'
  },
  {
    name: 'Staff Pickup and Drop Cab Pune',
    description: 'Round-the-clock employee pickup and drop services for companies operating across different shifts. Our cabs can be scheduled according to your office timings and employee transportation requirements.'
  },
  {
    name: 'Corporate Client Transport Pune',
    description: 'Provide your visiting clients with clean, comfortable, chauffeur-driven cabs. From airport pickups to hotel, office, and meeting transfers, we help manage complete corporate client transportation.'
  },
  {
    name: 'Pune Airport Corporate Cabs',
    description: 'Our corporate airport cabs provide convenient connectivity to Pune Airport for employees, executives, and business guests, with pre-booked pickups, professional chauffeurs, and scheduled arrival and drop services.'
  },
  {
    name: 'Business Meeting Cabs Pune',
    description: 'Attending multiple business meetings across Pune, Hinjewadi, Kharadi, Baner, or Pimpri-Chinchwad? Our hourly and daily cab rentals provide convenient transportation and flexible scheduling for busy corporate itineraries.'
  }
],

tableData: [
  ['Pune Corporate Cab Rentals', 'Business Cab Services Pune'],
  ['Employee Transport Cab Pune', 'Corporate Staff Cabs Pune'],
  ['Reliable Corporate Cab Service Pune', 'AC Corporate Cabs Pune'],
  ['Pune Office Commute Cabs', 'Corporate Event Cab Rentals Pune'],
  ['Affordable Corporate Cabs Pune', 'Executive Cab Service Pune'],
  ['Pune Business Travel Cabs', 'Staff Pickup and Drop Cab Pune'],
  ['Corporate Client Transport Pune', 'Pune Airport Corporate Cabs'],
  ['Business Meeting Cabs Pune', '']
],




"whychoose": [
    {
        "WhyChooseheading": "Dependable Corporate Cab Service in Pune",
        "WhyChoosedescription": "eTravo provides structured and professional corporate cab services in Pune, supporting IT companies, business parks, manufacturing units, and commercial establishments with safe, punctual, and convenient transportation solutions."
    },
    {
        "WhyChooseheading": "Fleet Options for Every Corporate Requirement",
        "WhyChoosedescription": "Our fleet includes hatchbacks, sedans, SUVs, and MPVs suitable for employee transportation, executive travel, airport transfers, client pickups, and intercity business trips."
    },
    {
        "WhyChooseheading": "Fixed Cab Assignments with Professional Chauffeurs",
        "WhyChoosedescription": "We provide dedicated vehicles and trained chauffeurs for corporate clients, helping maintain consistent service, punctual pickups, and familiarity with regular office routes and schedules."
    },
    {
        "WhyChooseheading": "Shift-Based Employee Transport Solutions",
        "WhyChoosedescription": "With Pune's growing IT, manufacturing, and commercial sectors operating across multiple shifts, eTravo offers customized employee transportation plans for morning, evening, night, and rotational shifts."
    },
    {
        "WhyChooseheading": "Real-Time GPS Tracking and Trip Monitoring",
        "WhyChoosedescription": "Our GPS-enabled corporate cabs allow trip monitoring, route tracking, and ETA visibility, helping HR, administration, and transport teams manage employee transportation efficiently."
    },
    {
        "WhyChooseheading": "Flexible Corporate Cab Packages",
        "WhyChoosedescription": "Choose from daily, weekly, monthly, hourly, or contract-based cab packages according to your company's transportation requirements. Our flexible plans are designed for businesses of different sizes."
    },
    {
        "WhyChooseheading": "Clean, Comfortable, and Safety-Focused Vehicles",
        "WhyChoosedescription": "Our cabs are regularly cleaned, maintained, and inspected to provide a comfortable travel experience. Safety-focused practices and trained chauffeurs help ensure secure transportation for employees and corporate guests."
    },
    {
        "WhyChooseheading": "Monthly GST Billing and Detailed Trip Reports",
        "WhyChoosedescription": "We provide organized billing with GST-compliant invoices, trip details, and usage reports, making corporate transportation expenses easier to monitor, verify, and manage."
    }
]

}


const faqData = [
    [
        {
            question: 'Which areas in and around Pune are covered?',
            answer: 'We provide corporate cab services across major business and commercial locations including Hinjewadi, Kharadi, Baner, Wakad, Viman Nagar, Hadapsar, Pimpri-Chinchwad, Yerawada, and nearby industrial and IT zones.'
        },
        {
            question: 'Do you offer shift-based cab services for employees?',
            answer: 'Yes, eTravo provides shift-based employee transportation for companies operating in morning, afternoon, evening, and night shifts, with schedules customized according to office timings.'
        },
        {
            question: 'Can we book dedicated cabs for senior management?',
            answer: 'Absolutely. We offer executive sedans and SUVs with professional chauffeurs for senior management, business leaders, visiting clients, and VIP corporate travel in Pune.'
        },
        {
            question: 'Do you provide GPS tracking for corporate cabs?',
            answer: 'Yes, our corporate cabs are equipped with GPS tracking to help monitor routes, trip progress, and estimated arrival times for better transportation management.'
        },
        {
            question: 'Do you offer monthly corporate cab packages?',
            answer: 'Yes, businesses can choose from monthly, contract-based, hourly, daily, and customized cab packages depending on their employee transportation and corporate travel requirements.'
        },
        {
            question: 'Will we receive monthly GST-compliant invoices?',
            answer: 'Yes, eTravo provides GST-compliant invoices along with detailed trip records and usage reports to simplify corporate billing, expense tracking, and financial reporting.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Rahul Kulkarni',
        designation: 'Transport Manager, Pune IT Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has made our employee transportation much easier to manage. Their corporate cab services in Pune are punctual, well-organized, and reliable for our daily office shifts.”'
    },
    {
        name: 'Ms. Neha Deshmukh',
        designation: 'Admin Manager, Pune Manufacturing Group',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo for employee pickups, executive travel, and airport transfers. Their professional chauffeurs, clean vehicles, and smooth billing process have been very helpful for our business.”'
    }
];





















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Pune",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-service-in-pune.png",
  "description": "Book reliable corporate cab services in Pune with eTravo. Ideal for employee transportation, office commutes, business meetings, executive travel, and airport transfers. Enjoy comfortable AC cabs, professional chauffeurs, GPS-enabled vehicles, and flexible corporate travel solutions.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7894"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/Corporate-Cab-Service-in-Pune"
  }
};








    return (
        <div>
<Helmet>
  <title>Corporate Cab Service in Pune | Staff Transport & Business Cabs | eTravo</title>
  <meta
    name="description"
    content="Hire reliable corporate cab services in Pune for employee transport, office commutes, business meetings, executive travel, and airport transfers. Book affordable AC corporate cabs with professional chauffeurs from eTravo."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/corporate-cab-service-in-pune.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinpunee;